import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/layout/Header";
import ClientSidebar from "../../components/layout/ClientSidebar";

// IMPORTAR O BANNER DE ASSINATURA
import SubscriptionBanner from "../../components/common/SubscriptionBanner";

const ClientLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  return (
    // FIX SCROLL:
    // 1. h-screen w-screen flex: Coloca a Sidebar e o Conteúdo lado a lado nativamente
    // 2. overflow-hidden: Previne qualquer vazamento global
    <div className="h-screen w-screen overflow-hidden bg-light-bg dark:bg-dark-bg text-light-text-primary dark:text-dark-text-primary flex">
      
      {/* SIDEBAR: Já está configurada no arquivo dela para ficar fixa no mobile e estática no Desktop */}
      <ClientSidebar
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={toggleSidebar}
      />

      {/* CONTAINER PRINCIPAL (Lado Direito) */}
      <div className="flex-1 flex flex-col min-w-0 h-screen relative">
        
        {/* HEADER: Ocupa o topo naturalmente sem precisar ser 'fixed' */}
        <Header isSidebarOpen={isSidebarOpen} onToggleSidebar={toggleSidebar} />

        {/* MAIN: 
           1. flex-1: Ocupa todo o resto da altura abaixo do header
           2. overflow-y-auto: A rolagem acontece APENAS aqui
           3. Removido o mt-[72px] fantasma que causava o buraco! 
        */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 lg:p-8 custom-scrollbar">
          
          {/* Banner de Assinatura */}
          <div className="mb-6 animate-fade-in">
            <SubscriptionBanner />
          </div>

          {/* Renderiza a página atual */}
          <Outlet />

          {/* Espaço extra no final para garantir que nada fique cortado no mobile */}
          <div className="h-20 lg:h-0 shrink-0"></div>
        </main>

      </div>
    </div>
  );
};

export default ClientLayout;